import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  BsBroadcast,
  BsCheckCircle,
  BsHeart,
  BsHeartFill,
  BsImage,
  BsPencil,
  BsTrash,
} from "react-icons/bs";
import { formatPrice, offerMerchant, offerSelo } from "./offerPresentation";

const QUALITIES = [
  { key: "Excelente", cls: "is-excelente", label: "Exce." },
  { key: "Bom", cls: "is-bom", label: "Bom" },
  { key: "Esgotou", cls: "is-esgotou", label: "Esg." },
];

const SELOS = ["Neutro", "Excelente", "Bom", "Esgotou"];

export default function OfertaCard({
  product,
  onQuality,
  onDelete,
  onEdit,
  onLive,
  onDestaque,
  isAdmin,
  showCode = false,
  showLive,
  addedToLive = [],
  variant = "grid",
}) {
  const alreadyLive = addedToLive.includes(product.id);
  const history = useHistory();
  const [copied, setCopied] = useState(false);

  const selo = SELOS.includes(product.selo) ? product.selo : "Neutro";
  const meta = offerSelo({ selo });
  const esgotada = selo === "Esgotou";
  const price = formatPrice(product.offer_price);
  const merchant = offerMerchant(product);
  const showMerchant = merchant && merchant !== "Oferta";
  const isList = variant === "list";
  const CouponTag = isList ? "button" : "span";
  const CtaTag = isList ? "button" : "div";

  const go = () => {
    if (product.link) window.open(product.link, "_blank", "noopener");
    else history.push(`/produto/${product.id}`);
  };

  const copyCoupon = (e) => {
    e.stopPropagation();
    if (navigator.clipboard) navigator.clipboard.writeText(product.cupom);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <article
      className={`oav-card oav-card--${variant} oav-tone-${meta.key} ${
        esgotada ? "is-esgotada" : ""
      } ${isAdmin ? "is-managed" : ""}`}
    >
      {!isList && <button
        type="button"
        className="oav-card-target"
        onClick={go}
        aria-label={`Abrir ${product.name}`}
      />}

      <div className="oav-card-media">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} loading="lazy" />
        ) : (
          <BsImage className="oav-card-ph" aria-hidden="true" />
        )}

        {!esgotada && meta.band ? (
          <span className={`oav-band oav-band--${meta.key}`}>{meta.label}</span>
        ) : null}

        {esgotada ? <span className="oav-esgotada">Oferta Esgotada!</span> : null}
      </div>

      <div className="oav-card-body">
        <div className="oav-card-title-block">
          <h3 className="oav-card-title">{product.name}</h3>
          {showMerchant || (showCode && product.code) ? (
            <div className="oav-card-meta">
              {showMerchant ? (
                <span className="oav-card-merchant">{merchant}</span>
              ) : null}
              {showCode && product.code ? (
                <span className="oav-code">{product.code}</span>
              ) : null}
            </div>
          ) : null}
        </div>

        <div className="oav-card-price">
          {price || <span className="oav-no-price">Preço no link</span>}
        </div>

        <div className="oav-card-tags">
          {product.cupom ? (
            <CouponTag
              type={isList ? "button" : undefined}
              className={`oav-cupom-tag ${product.link_resgate ? "com-link" : ""}`}
              onClick={copyCoupon}
              role={isList ? undefined : "button"}
              tabIndex={isList ? undefined : 0}
              title="Toque para copiar"
            >
              {copied ? "Copiado!" : `Cupom: ${product.cupom}`}
            </CouponTag>
          ) : null}

          {product.link_resgate ? (
            <a
              className="oav-resgate-tag"
              href={product.link_resgate}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.stopPropagation();
                if (product.cupom && navigator.clipboard) {
                  navigator.clipboard.writeText(product.cupom);
                }
              }}
              title="Copia o cupom e abre o site"
            >
              Resgatar cupom
            </a>
          ) : null}
        </div>
      </div>

      <CtaTag className="oav-card-cta" type={isList ? "button" : undefined}
        onClick={isList ? go : undefined}>
        {esgotada ? (
          <>
            <span className="oav-cta-desktop">Esgotado</span>
            <span className="oav-cta-mobile">Esgotou</span>
          </>
        ) : (
          <>
            <span className="oav-cta-desktop">Ir para oferta</span>
            <span className="oav-cta-mobile">Ir para oferta</span>
          </>
        )}
      </CtaTag>

      {isAdmin && (
        <div className="oav-admin-row">
          <div className="oav-q-btns">
            {QUALITIES.map((q) => (
              <button
                key={q.key}
                type="button"
                className={`oav-selo ${q.cls} ${selo === q.key ? "is-active" : ""}`}
                title={`Marcar como ${q.key}`}
                aria-label={`Classificação ${q.key}`}
                aria-pressed={selo === q.key}
                onClick={(e) => {
                  e.stopPropagation();
                  onQuality(product.id, selo === q.key ? "Neutro" : q.key);
                }}
              >
                {q.label}
              </button>
            ))}
          </div>
          <div className="oav-admin-actions">
            {onDestaque && (product.board || "ao_vivo") === "ao_vivo" && (
              <button
                type="button"
                className={`oav-icon-btn oav-fav ${product.destaque ? "is-on" : ""}`}
                title={product.destaque ? "Remover dos destaques" : "Destacar oferta"}
                aria-label={product.destaque ? "Remover dos destaques" : "Destacar oferta"}
                onClick={(e) => {
                  e.stopPropagation();
                  onDestaque(product);
                }}
              >
                {product.destaque ? <BsHeartFill /> : <BsHeart />}
              </button>
            )}
            {showLive &&
              (alreadyLive ? (
                <span className="oav-icon-btn oav-live-btn is-live" title="Já está nas Ofertas Live">
                  <BsCheckCircle />
                </span>
              ) : (
                <button
                  type="button"
                  className="oav-icon-btn oav-live-btn"
                  title="Adicionar às Ofertas Live"
                  aria-label="Adicionar às Ofertas Live"
                  onClick={(e) => {
                    e.stopPropagation();
                    onLive(product);
                  }}
                >
                  <BsBroadcast />
                </button>
              ))}
            <button
              type="button"
              className="oav-icon-btn"
              title="Editar oferta"
              aria-label="Editar oferta"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(product);
              }}
            >
              <BsPencil />
            </button>
            <button
              type="button"
              className="oav-icon-btn oav-del"
              title="Excluir oferta"
              aria-label="Excluir oferta"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(product);
              }}
            >
              <BsTrash />
            </button>
          </div>
        </div>
      )}
    </article>
  );
}
